export const FETCH_POSITIONS_REQUEST = "position/FETCH_POSITIONS_REQUEST";
export const FETCH_POSITIONS_SUCCESS = "position/FETCH_POSITIONS_SUCCESS";
export const FETCH_POSITIONS_FAILURE = "position/FETCH_POSITIONS_FAILURE";

export const ADD_POSITION_REQUEST = "position/ADD_POSITION_REQUEST";
export const ADD_POSITION_SUCCESS = "position/ADD_POSITION_SUCCESS";
export const ADD_POSITION_FAILURE = "position/ADD_POSITION_FAILURE";

export const FETCH_POSITION_REQUEST = "position/FETCH_POSITION_REQUEST";
export const FETCH_POSITION_SUCCESS = "position/FETCH_POSITION_SUCCESS";
export const FETCH_POSITION_FAILURE = "position/FETCH_POSITION_FAILURE";

export const UPDATE_POSITION_REQUEST = "position/UPDATE_POSITION_REQUEST";
export const UPDATE_POSITION_SUCCESS = "position/UPDATE_POSITION_SUCCESS";
export const UPDATE_POSITION_FAILURE = "position/UPDATE_POSITION_FAILURE";

export const CLEAR_POSITION_VALUES = "position/CLEAR_POSITION_VALUES";
